<template>
<div>
    <b-overlay :show="this.$store.getters.GET_REGISTER.loading" :opacity="0.4">
        <form class="register-form" @submit.prevent="processRegistration" method="post">
            <span class="register-form__login-now">{{ TEXTS.render(`REGISTRATION_FORM_LOGIN_TEXT`) }}  <router-link class="pl-2 d-block" to="/"> {{ TEXTS.render(`REGISTRATION_FORM_LOGIN_LINK`) }}</router-link></span>
            <h2 class="register-form__title" id="form-entry">{{ TEXTS.render(`REGISTRATION_FORM_HEADER`) }}</h2>
            <p class="mb-4">{{ TEXTS.render(`REGISTRATION_FORM_SUBHEADER`) }} </p>
            <div v-if="emailNotVerified == true" class="text-danger font-sm font-weight-bold mb-2" role="alert">
                Email address is not verified, please check your email or <button class="btn-link" @click="resendConfirmationEmail(tokenHash)" :disabled="!!saving">click here </button> to send another verification link
            </div>
            <div class="text-danger font-sm mb-2" role="alert" v-html="errorMessage" />
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group mb-4">
                        <label class="font-weight-bold mb-1 required" for="details-firstname">{{ TEXTS.render(`REGISTRATION_FORM_FIRSTNAME_HEADER`) }}</label>
                        <!-- <input type="text" class="form-control" v-model="details.firstName" @keyup="firstNameValidate" placeholder="Your first name"> -->
                        <input id="details-firstname" type="text" class="form-control" v-model="details.firstName" :placeholder="TEXTS.render(`REGISTRATION_FORM_FIRSTNAME_PLACEHOLDER`)">
                        <div class="register-form__validation mt-1 text-danger font-weight-bold" role="alert" v-html="validations.firstName" />
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group mb-4">
                        <label class="font-weight-bold mb-1 required" for="details-lastname">{{ TEXTS.render(`REGISTRATION_FORM_LASTNAME_HEADER`) }}</label>
                        <!-- <input type="text" class="form-control" v-model="details.lastName" @keyup="lastNameValidate" placeholder="Your last name"> -->
                        <input id="details-lastname" type="text" class="form-control" v-model="details.lastName" :placeholder="TEXTS.render(`REGISTRATION_FORM_LASTNAME_PLACEHOLDER`)">
                        <div class="register-form__validation mt-1 text-danger font-weight-bold" role="alert" v-html="validations.lastName" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group mb-4">
                        <label class="font-weight-bold mb-1 required" for="details-phone">{{ TEXTS.render(`REGISTRATION_FORM_PHONE_HEADER`) }}</label>
                        <!-- <input type="number" class="form-control" v-model="details.phone" @keyup="phoneValidate" placeholder="Phone" @keydown="phoneValidate"> -->
                        <input id="details-phone" type="number" class="form-control" v-model="details.phone" :placeholder="TEXTS.render(`REGISTRATION_FORM_PHONE_PLACEHOLDER`)">
                        <div v-bind:class="{ 'text-danger' : validations.phone != '', 'font-weight-bold' : validations.phone != ''}" class="register-form__validation mt-1" role="alert" v-html="validations.phone" />
                        <div v-bind:class="{ 'd-none' : validations.phonecheck == 'yes' }" class="register-form__validation mt-1  ">Please include area code for landline numbers</div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group mb-4">
                        <label class="font-weight-bold mb-1 required" for="details-email">{{ TEXTS.render(`REGISTRATION_FORM_EMAIL_HEADER`) }}</label>
                        <!-- <input type="text" class="form-control" v-model="details.email" @keyup="emailValidate" placeholder="Email Address"> -->
                        <input id="details-email" type="text" class="form-control" v-model="details.email" :placeholder="TEXTS.render(`REGISTRATION_FORM_EMAIL_PLACEHOLDER`)">
                        <div class="register-form__validation mt-1 text-danger font-weight-bold" role="alert" v-html="validations.email" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group mb-4">
                        <label class="font-weight-bold mb-1 required" for="details-password">{{ TEXTS.render(`REGISTRATION_FORM_PASSWORD_HEADER`) }}</label>
                        <!-- <input type="password" class="form-control" v-model="details.password" @keyup="passwordValidate" placeholder="Password"> -->
                        <input id="details-password" type="password" class="form-control" v-model="details.password" :placeholder="TEXTS.render(`REGISTRATION_FORM_PASSWORD_PLACEHOLDER`)">
                        <div v-bind:class="{ 'text-danger' : validations.password != '', 'font-weight-bold' : validations.password != ''}" class="register-form__validation mt-1" role="alert" v-html="TEXTS.render(`REGISTRATION_FORM_PASSWORD_NOTE`)" />
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group mb-4">
                        <label class="font-weight-bold mb-1 required" for="details-repassword">{{ TEXTS.render(`REGISTRATION_FORM_PASSWORD_RETYPE_HEADER`) }}</label>
                        <input id="details-repassword" type="password" class="form-control" v-model="details.retypePassword" @keyup="retypePasswordValidate" :placeholder="TEXTS.render(`REGISTRATION_FORM_PASSWORD_RETYPE_PLACEHOLDER`)">
                        <div class="register-form__validation mt-1 text-danger font-weight-bold" role="alert" v-html="validations.retypePassword" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group register-form__privacy">
                        <label class="font-weight-bold mb-1 required">{{ TEXTS.render(`REGISTRATION_FORM_PRIVACY_HEADER`) }}</label>
                        <privacy-statement @onChange="privacyOnChange"></privacy-statement>
                        <div class="register-form__validation mt-1 text-danger font-weight-bold" role="alert" v-html="validations.privacy" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                    <div v-if="csoEnabled === 'false' && recaptchaDisabled === 'false'" class="recaptcha-wrapper">
                        <recaptcha @onChange="recaptchaOnChange" v-if="csoEnabled === 'false' && recaptchaDisabled === 'false'"></recaptcha>
                        <div class="register-form__validation mt-1 text-danger font-weight-bold" role="alert" v-html="validations.recaptcha" />
                    </div>
                </div>
            </div>
            <ColoredButton id="registerBtn">{{ TEXTS.render(`REGISTRATION_FORM_BTN_SIGN_UP`) }}</ColoredButton>
        </form>
    </b-overlay>
    <ConfirmationModal modalId="verificationEmailModal" triggerEventName="confirmToSendVerification"/>
    <RegistrationSuccessModal modalId="confirmRegistrationModal" triggerEventName="confirmRegistrationSuccess"/>
</div>
</template>

<script>
    import helper from '../../../../helper';
    import PrivacyStatement from './PrivacyStatement';
    import Recaptcha from '../../../../common/components/Recaptcha';
    import ConfirmationModal from '../../../../common/components/ConfirmationModal';
    import ColoredButton from '../../../../common/components/ColoredButton';
    import RegistrationSuccessModal from '../../../../common/components/RegistrationSuccessModal';
    import Texts from '../../../../common/utils/Texts'
    import RecaptchaDetectDebugMixin from '../../../../common/mixins/RecaptchaDetectDebugMixin'
    export default {
        mixins: [RecaptchaDetectDebugMixin],
        components: {
            PrivacyStatement,
            Recaptcha,
            ConfirmationModal,
            ColoredButton,
            RegistrationSuccessModal
        },
        data() {
            return {
                recaptchaDisabled: localStorage.recaptchaDisabled,
                csoEnabled: localStorage.csoEnabled,
                recaptchaAccepted: false,
                privacyAccepted: false,
                details: {
                    firstName: '',
                    lastName: '',
                    phone: '',
                    email: '',
                    password: '',
                    retypePassword: ''
                },
                validations: {
                    firstName: '',
                    lastName: '',
                    phone: '',
                    email: '',
                    password: '',
                    retypePassword: '',
                    privacy: '',
                    recaptcha: '',
                    valid: true
                },
                emailNotVerified: false,
                tokenHash:'',
                errorMessage:'',
                saving: false,
            }
        },
        methods: {
            // blockPaste : function(event){
            // },
            processRegistration() {
                this.errorMessage = '';
                this.emailNotVerified = false;
                this.validateAll();

                if (!this.validations.valid) {
                    helper.scrollIntoView('form-entry');
                }

                if (!this.privacyAccepted) {
                    this.validations.valid = false;
                    this.validations.privacy = 'Please confirm the privacy statement';
                }

                if ((this.csoEnabled === 'false' && this.recaptchaDisabled === 'false') && typeof this.recaptchaAccepted !== 'string') {
                    this.validations.valid = false;
                    this.validations.recaptcha = 'Please confirm that you are a human';
                }

                if (this.validations.valid && this.privacyAccepted && !this.saving) {
                    this.saving = true;
                    this.errorMessage = '';
                    this.callRegistrationSuccess();
                }
            },
            privacyOnChange(e) {
                this.privacyAccepted = e;
            },
            recaptchaOnChange(e) {
                if (typeof e === 'string') {
                    this.recaptchaAccepted = e;
                }

                if (e === undefined) {
                    this.recaptchaAccepted = false;
                    this.validations.valid = false;
                    this.validations.recaptcha = 'Please confirm that you are a human';
                }
            },
            validateAll() {
                this.validations.valid = true;
                this.validations.privacy = '';
                this.validations.recaptcha = '';
                this.firstNameValidate();
                this.lastNameValidate();
                this.phoneValidate();
                this.emailValidate();
                this.passwordValidate();
                this.retypePasswordValidate();
            },
            firstNameValidate() {
                this.validations.firstName = '';
                if (!(/^[^-\s][a-zA-Z0-9_\s-]+$/i.test(this.details.firstName) && this.details.firstName.length <= 50)) {
                    this.validations.valid = false; 
                    this.validations.firstName = Texts.render(`REGISTRATION_FORM_VALIDATION_FIRSTNAME`);
                }
            },
            lastNameValidate() {
                this.validations.lastName = '';
                if (!(/^[^-\s][a-zA-Z0-9_\s-]+$/i.test(this.details.lastName) && this.details.lastName.length <= 50)) {
                    this.validations.valid = false;
                    this.validations.lastName = Texts.render(`REGISTRATION_FORM_VALIDATION_LASTNAME`);
                }
            },
            phoneValidate() {
                this.validations.phone = '';
                this.validations.phoneCheck = '';
                if (!(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{2,4}$/im.test(this.details.phone))) {
                    this.validations.valid = false;
                    this.validations.phone = Texts.render(`REGISTRATION_FORM_VALIDATION_PHONE_LIMIT`);
                    this.validations.phonecheck = 'yes';
 
                }
            },
            emailValidate() {
                this.validations.email = '';
                if (!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.details.email)) || !(/^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,10})+$/.test(this.details.email))) {
                    this.validations.valid = false;
                    this.validations.email = Texts.render(`REGISTRATION_FORM_VALIDATION_EMAIL`);
                }
            },
            passwordValidate() {
                this.validations.password = '';
                if (!(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,60}$/.test(this.details.password))) {
                    this.validations.valid = false;
                    this.validations.password = Texts.render(`REGISTRATION_FORM_VALIDATION_PASSWORD`);
                }
            },
            retypePasswordValidate() {
                this.validations.retypePassword = '';
                if (this.details.password !== this.details.retypePassword) {
                    this.validations.valid = false;
                    this.validations.retypePassword = Texts.render(`REGISTRATION_FORM_VALIDATION_RETYPE`);
                }
            },
            resendConfirmationEmail(hashCode) {
               this.confirmToSendVerification(hashCode);
            },
            confirmToSendVerification(hashCode, next) {
                this.$emit(
                    "confirmToSendVerification", 
                    "Email will be sent to " + this.details.email,
                    function(){
                        this.$store.dispatch('resendConfirmationEmail', hashCode);
                        setTimeout(next, 100) 
                    }
                )
            },
            callRegistrationSuccess() {
                this.errorMessage = "";
               // Do API request
               this.$store.dispatch('registerProcess', {
                    email: this.details.email,
                    password: this.details.password,
                    firstname: this.details.firstName,
                    lastname: this.details.lastName,
                    phone: this.details.phone,
                    limit: 10
                });
            }
        },
        mounted() {
            localStorage.csoEnabled = this.$route.query && this.$route.query.cso === 'true' ? 'true' : 'false';
            this.csoEnabled = localStorage.csoEnabled;
        },
        computed: {
            TEXTS: ()=> Texts,
            loading() {
                return this.$store.getters['GET_PAGE_LOADING'];
            },
            error() {
                if (this.$store.getters['GET_REGISTER'].error && this.$store.getters['GET_REGISTER'].error !== 'Email address is not verified') {
                    return this.$store.getters['GET_REGISTER'].error;
                }
            },
            registrationSuccess() {
                return this.$store.getters['GET_REGISTER'];
            },
            resendEmailURL(){
                return this.$store.getters.GET_RESEND_CONFIRMATION_EMAIL.message
            }
        },
        watch: {
            'error': function(message) {
                this.$nextTick(function() {
                    this.errorMessage = message
                    this.saving = false;
                    helper.scrollIntoView('form-entry');
                });
            },
            'resendEmailURL': function(message) {
                this.$nextTick(function() {
                    this.emailNotVerified = false;
                    this.errorMessage = message;
                    helper.scrollIntoView('form-entry');
                });
            },
            'registrationSuccess': function(success) {
                if(success.loading == false){
                    if (success.message == 'Email address is not verified') {
                        this.saving = false;
                        this.errorMessage = "Error occurred during registration. Email already exists.";
                    }
                    if (success.message == 'Registration Successful.'){
                        this.errorMessage = "";
                        $('#registrationSuccess').modal({
                            backdrop: 'static',
                            keyboard: false
                        });
                    }
                }
            }
        }
    }

</script>
